import React from 'react';
import { OrderedMap, List as ImmutableList } from "immutable";
import { Form, Row, Col, Button, Divider, message } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { Table } from "components";
import AddSlabDrawer from './add-slab-drawer';
import  CompanyService  from 'services/company-service';
import  { ANCHOR_FEES_FIELDS }  from "constants/form-fields";
import { MpaFormsFooter } from '../../modules/companies/modules/mpa-form-footer';



const SLAB_LIST_COLS = (props) =>  new OrderedMap({
    from_amount: {
        title: "From (in Crs)",
        dataIndex: "from_amount",
        key: "from_amount",
        width: 40,
        render : _ => _,
        align: "center",
    },
    to_amount: {
        title: "To (in Crs)",
        dataIndex: "to_amount",
        key: "to_amount",
        width: 40,
        align: "center",
        render : _ => _,
    },

    fee_type: {
        title: "Fee Type",
        dataIndex: "fee_type",
        key: "fee_type",
        width: 40,
        render: (_) => _ == 1 ? "Fixed" : "Percentage",
        align: "center"
    },
    fee_amount: {
        title: "Fee Amount",
        dataIndex: "fee_amount",
        key: "fee_amount",
        width: 40,
        render : (_) => _ || "-",
        align: "center"
    },
    fee_perc: {
        title: "Fee Perc",
        dataIndex: "fee_perc",
        key: "fee_perc",
        width: 40,
        render : (_) => ( _ && _ + '%') || "-",
        align: "center"
    },
    action: {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: 80,
        render : (_,data) => <Button type="link" disabled={props.disableFields} onClick={() => props.deleteSlab(data.id)}>Delete</Button>
    }
})




class AnchorFeesForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    state = {
        formValues: {},
        addSlabVisible: false,
        createSlabLoader : false
    }

    handleFieldValueChange = (fieldName, value) => {
        if(fieldName == "fee_basis"){
            if(value == 4){
                this.props.form.setFieldsValue({
                    charges_at: null,
                    payment_frequency: null,
                    is_slab_based: false,
                    fee_type: null,
                    fee_amount: null,
                    fee_perc: null,    
                });
            }
        }

        if (fieldName == "charges_at") {
            if(value == 3){
                this.props.form.setFieldsValue({
                    payment_frequency: null,
                    is_slab_based: false,
                    fee_type: null,
                    fee_amount: null,
                    fee_perc: null,    
                })
            }
        }
        if (fieldName == "is_slab_based") {
            this.props.form.setFieldsValue({
                fee_type: null,
                fee_amount: null,
                fee_perc: null
            })
        }

        if (fieldName == "fee_type") {
            this.props.form.setFieldsValue({
                fee_amount: null,
                fee_perc: null
            })
        }
    }

    onApprove = (e) => {
        e.preventDefault();
        const formValues = {};
        const formFields = ANCHOR_FEES_FIELDS;
        formFields.forEach((field, fieldName) => {
            formValues[fieldName] = this.props.form.getFieldValue(fieldName);
        });

        this.props.form.validateFields((err, values) => {
            if (!err) {
                const formData = this.props.form.getFieldsValue()
                this.props.updateDetail(formData);

            }
        })
    }

    getFormValues = (formKey) => {
        const formValues = {};
        const formFields = this.state.forms[formKey];
        for (const fieldName in formFields) {
            formValues[fieldName] = formFields[fieldName].value;
        }
        return formValues;
    }

    handleAddSlabDrawer = () => {
        this.setState({
            addSlabVisible: !this.state.addSlabVisible
        })
    }

    createSlab = (values) => {
        // Remove undefined values
        const cleanedData = Object.fromEntries(Object.entries(values).filter(([_, value]) => value !== undefined));

        // Remove 'slab_' prefix from keys
        const formattedData = Object.fromEntries(
            Object.entries(cleanedData).map(([key, value]) => [key.replace(/^slab_/, ''), value])
        );
        const data = {
            "mpa_approval": this.props.currentMpaId,
            ...formattedData
        }
        this.setState({ createSlabLoader: true  })

        CompanyService.createSlab(data)
            .then(_ => {
                this.setState({
                    createSlabLoader: false
                })
                this.handleAddSlabDrawer();
                this.props.fetchMpaDetails();
            })
            .catch((err) => {
                this.setState({
                    createSlabLoader: false
                })
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            })

    }

    render() {
        const  {createSlabLoader , addSlabVisible} = this.state;
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Form key="feeForm" onSubmit={this.onApprove}>
                    <Row>
                        <AddSlabDrawer 
                            loading={createSlabLoader}
                            visible={addSlabVisible}
                            onClose={this.handleAddSlabDrawer}
                            createSlab = {(values) => this.createSlab(values)}
                        />
                        {ANCHOR_FEES_FIELDS.map((field, fieldName) => {
                            field.disabled = this.props.disableFields;
                            const value = this.props.values && this.props.values.get(fieldName);
                           
                            if(!this.props.disableFields){

                                if(fieldName != "fee_basis"){
                                    const fee_basis = this.props.form.getFieldValue("fee_basis");
                                    if(fee_basis == 4){
                                        field.disabled = true;
                                        field.rules = [];
                                    }else{
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            }
                                        ]
                                    }


                                    if(fieldName != "charges_at"){
                                        const charges_at = this.props.form.getFieldValue("charges_at");
                                        if(charges_at == 3 && !["fee_type", "payment_frequency"].includes(fieldName)){
                                            field.disabled = true;
                                            field.rules = [];
                                        }else if(fee_basis != 4){
                                            field.disabled = false;
                                            field.rules = [
                                                {
                                                    required: true,
                                                    message: "Field is Required"
                                                }
                                            ]
                                        }
                                    }
                                }
                               

                                if (fieldName == "fee_perc") {
                                    const fee_type = this.props.form.getFieldValue("fee_type");
                                    if (fee_type == 1) {
                                        field.disabled = true;
                                        field.rules = [{
                                                required: false
                                        }];
                                       
                                    } else if(fee_type == 2) {
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            },
                                            {
                                                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                                message: "Input must be between 0 and 100"
                                            }
                                        ];
                                    }
                                }
                                if (fieldName == "fee_amount") {
                                    const fee_type = this.props.form.getFieldValue("fee_type");
                                    if (fee_type == 1) {
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            },
                                            {
                                                pattern: /^(0|[1-9]\d*)$/,
                                                message: "Please enter a number"
                                            }
                                        ];
                                    } else if(fee_type == 2) {
                                        field.disabled = true;
                                        field.rules = [{
                                                required: false
                                        }];
                                    }
                                }
                                if(fieldName == "add_slab") {
                                    const is_slab_based = this.props.form.getFieldValue("is_slab_based");
                                    if(is_slab_based){
                                        field.onClick = this.handleAddSlabDrawer;
                                        field.disabled = false;
                                    }else{
                                        field.onClick = null
                                        field.disabled = true;
                                    }
                                    field.rules = []
                                }
                                if(["fee_amount" , "fee_perc" , "fee_type"].includes(fieldName)){
                                    const is_slab_based = this.props.form.getFieldValue("is_slab_based");
                                    if(is_slab_based){
                                        field.disabled = true;
                                        field.rules = [{
                                                required: false
                                        }];
                                    }

                                }
                            }                           
                            return <Col span={field.col}>{this.fieldGenerator(
                                fieldName,
                                { ...field, value },
                                this.getValidateStatus(fieldName),
                                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e :  e.target.value)),
                                true
                            )()}</Col>
                        }).toList()}
                    </Row>
                    <Row>
                        <MpaFormsFooter
                            disableFields={this.props.disableFields}
                            approveDisabled={this.props.approveDisabled}
                            onApprove={this.props.approveDetails}
                        />
                    </Row>
                </Form>
                <Divider />
                {this.props.form.getFieldValue('is_slab_based') && <Row className='mt-10'>
                    <Table
                        title={"Slabs"}
                        spanConfig={{
                            btnSpan: 12,
                            title : 12
                        }}
                        showFilters={false}
                        custonButtonIcons={["plus"]}
                        customButtonTexts={["Add Slab"]}
                        showCustomButton={this.props.disableFields ? false :  true}
                        onCustomButtonClicks={[this.handleAddSlabDrawer]}
                        pagination={false}
                        showColumnSelector={false}
                        noRowSelection={true}
                        size={"small"}
                        columns={SLAB_LIST_COLS(this.props)}
                        data={ImmutableList(this.props.values.get('slabs'))}
                    />
                </Row>}
            </div>
        );
    }
}
export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    if(["fee_basis", "charges_at", "payment_frequency", "fee_type"].includes(key) && ["", 0].includes(value)){
                        return Form.createFormField({
                            value: 1
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(AnchorFeesForm);
